var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePicture04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Profile_Picture_-_04",
    width: 36,
    height: 36,
    "data-name": "Profile Picture - 04",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_367",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "none",
    "data-name": "Ellipse 367"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-16{fill:none}.prefix__cls-4{fill:#fdd761}.prefix__cls-5{fill:#8b5145}.prefix__cls-7{fill:#d1693b}.prefix__cls-8{fill:#af4b23}.prefix__cls-9{fill:#a57b37}.prefix__cls-10{fill:#ffded7}.prefix__cls-11{fill:#ccb683}.prefix__cls-12{fill:#b79251}.prefix__cls-13{fill:#e2d0ac}.prefix__cls-16{stroke:#737373;stroke-linecap:round;stroke-miterlimit:10;stroke-width:.268px}.prefix__cls-17{fill:#ffb9ae}.prefix__cls-18{fill:#efc9c2}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Profile_Picture_-_04-2",
    "data-name": "Profile Picture - 04"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3028",
    "data-name": "Group 3028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3027",
    clipPath: "url(#prefix__clip-path)",
    "data-name": "Group 3027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3026",
    "data-name": "Group 3026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1132",
    fill: "#0baf50",
    d: "M0 0H36V36H0z",
    "data-name": "Rectangle 1132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5344",
    d: "M1584.421 908.39c-.432-5.127-1.97-10.119-11.136-10.119-8.922 0-11.215 5.364-11.586 10.119z",
    className: "prefix__cls-4",
    "data-name": "Path 5344",
    transform: "translate(-1555.316 -893.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5345",
    d: "M1584.576 912.188c-1.018-4.1-3.7-7.658-12.309-7.656-8.282 0-11.387 3.741-12.35 7.656z",
    className: "prefix__cls-5",
    "data-name": "Path 5345",
    transform: "translate(-1554.298 -897.006)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_355",
    cx: 13.907,
    cy: 6.686,
    className: "prefix__cls-4",
    "data-name": "Ellipse 355",
    rx: 13.907,
    ry: 6.686,
    transform: "translate(4.114 10.714)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_356",
    cx: 13.551,
    cy: 6.514,
    fill: "#ce7b02",
    "data-name": "Ellipse 356",
    rx: 13.551,
    ry: 6.514,
    transform: "translate(4.471 10.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5346",
    d: "M1590.389 909.62l.135.026a26.06 26.06 0 0 1 3.513.945 5.261 5.261 0 0 1 3.343 3.169 12.848 12.848 0 0 1 .717 4.223 20.719 20.719 0 0 0-.052 3.059c.087.474.09.942.185 1.418.335 1.682 1.233 3.736-.229 5.17a3.054 3.054 0 0 1-1.07.664 3.639 3.639 0 0 1-1.692.2c-1.165-.138-2.253-.838-3.422-.738a6.593 6.593 0 0 0-1.728.525 3.093 3.093 0 0 1-1.768.244c-1.847-.435-.856-3.562-.986-4.884-.042-.428-.26-.881-.26-1.305a63.68 63.68 0 0 1-1.469-8.346c-.183-2.137-.285-4.15 2.366-4.516a7.537 7.537 0 0 1 2.417.146z",
    className: "prefix__cls-7",
    "data-name": "Path 5346",
    transform: "translate(-1568.931 -899.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5347",
    d: "M1569.2 909.62l-.135.026a26.065 26.065 0 0 0-3.513.945 5.26 5.26 0 0 0-3.343 3.169 12.839 12.839 0 0 0-.717 4.223 20.735 20.735 0 0 1 .052 3.059c-.087.474-.09.942-.185 1.418-.335 1.682-1.233 3.736.229 5.17a3.053 3.053 0 0 0 1.07.664 3.638 3.638 0 0 0 1.692.2c1.165-.138 2.253-.838 3.423-.738a6.593 6.593 0 0 1 1.728.525 3.093 3.093 0 0 0 1.768.244c1.847-.435.856-3.562.986-4.884.042-.428.26-.881.26-1.305a63.66 63.66 0 0 0 1.469-8.346c.183-2.137.285-4.15-2.366-4.516a7.541 7.541 0 0 0-2.418.146z",
    className: "prefix__cls-7",
    "data-name": "Path 5347",
    transform: "translate(-1554.787 -899.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5348",
    d: "M1571.612 909.475a7.541 7.541 0 0 0-2.417.144l-.135.026q-.743.145-1.477.334c.006.048.011.1.013.147a1.415 1.415 0 0 1-.415 1 19.064 19.064 0 0 0-2.6 2.428 7.65 7.65 0 0 0-1.262 2.967 14.944 14.944 0 0 0-.194 2.481 2.276 2.276 0 0 1-.428-1.2 4.307 4.307 0 0 0-.429.814 8.957 8.957 0 0 1-.214-1.2 8.694 8.694 0 0 0-.3 1.5 2.559 2.559 0 0 1-.267-.772 16.25 16.25 0 0 1 .055 2.894c-.087.474-.09.942-.185 1.418-.335 1.682-1.233 3.736.229 5.17a3.053 3.053 0 0 0 1.07.664 3.638 3.638 0 0 0 1.692.2c1.165-.138 2.253-.838 3.423-.738a6.593 6.593 0 0 1 1.728.525 3.093 3.093 0 0 0 1.768.244c1.847-.435.856-3.562.986-4.884.042-.428.26-.881.26-1.305a63.66 63.66 0 0 0 1.469-8.346c.179-2.132.281-4.145-2.37-4.511z",
    className: "prefix__cls-8",
    "data-name": "Path 5348",
    transform: "translate(-1554.787 -899.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5349",
    d: "M1587.982 909.475a7.54 7.54 0 0 1 2.417.144l.135.026q.742.145 1.476.334c-.006.048-.011.1-.013.147a1.413 1.413 0 0 0 .415 1 19.033 19.033 0 0 1 2.6 2.428 7.645 7.645 0 0 1 1.263 2.967 14.9 14.9 0 0 1 .194 2.481 2.277 2.277 0 0 0 .428-1.2 4.262 4.262 0 0 1 .429.814 8.957 8.957 0 0 0 .214-1.2 8.68 8.68 0 0 1 .3 1.5 2.546 2.546 0 0 0 .267-.772 16.307 16.307 0 0 0-.055 2.894c.087.474.09.942.185 1.418.335 1.682 1.233 3.736-.229 5.17a3.055 3.055 0 0 1-1.07.664 3.64 3.64 0 0 1-1.692.2c-1.165-.138-2.253-.838-3.423-.738a6.6 6.6 0 0 0-1.727.525 3.093 3.093 0 0 1-1.768.244c-1.847-.435-.856-3.562-.986-4.884-.042-.428-.26-.881-.26-1.305a63.682 63.682 0 0 1-1.47-8.346c-.179-2.132-.281-4.145 2.37-4.511z",
    className: "prefix__cls-8",
    "data-name": "Path 5349",
    transform: "translate(-1568.936 -899.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5350",
    d: "M1563.74 959.652c-2.046-1.372-1.782-2.442-1.782-2.442a3.6 3.6 0 0 1 3.548.81c1.646 1.435 1.2 2.686 1.2 2.686s-.506.594-2.966-1.054z",
    className: "prefix__cls-9",
    "data-name": "Path 5350",
    transform: "translate(-1555.458 -927.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5351",
    d: "M1568.757 964.775a1.679 1.679 0 0 1-.452-.062 9.761 9.761 0 0 1-4.156-2.187 5.778 5.778 0 0 1-1.829-3.526 6.63 6.63 0 0 1 1.224-4.505 11.468 11.468 0 0 1 3.938-3.48 1.679 1.679 0 1 1 1.638 2.932c-2.255 1.26-3.647 3.13-3.465 4.654.15 1.258 1.411 2.279 3.551 2.875a1.68 1.68 0 0 1-.45 3.3z",
    className: "prefix__cls-10",
    "data-name": "Path 5351",
    transform: "translate(-1555.648 -923.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5352",
    d: "M1570.249 950.464c-1.266 1.106-3.533 3.353-3.533 3.353a4.477 4.477 0 0 0-1.981-2.425 4.4 4.4 0 0 0-2.79-1.055 37.707 37.707 0 0 1 4.762-4.7l.057-.042a3.058 3.058 0 0 1 4.27.691 3.148 3.148 0 0 1-.785 4.178z",
    className: "prefix__cls-11",
    "data-name": "Path 5352",
    transform: "translate(-1555.456 -920.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5353",
    d: "M1569.676 951.065a1.841 1.841 0 0 1-.366.355.258.258 0 0 1-.308.022c-.223-.117-.277-.122-.451.072a2.8 2.8 0 0 0-.335.474c-.187.323-.333.677-.511 1-.082.147-.3.652-.505.638a.313.313 0 0 1-.125-.047q-.481-.258-.982-.476c-.165-.072-.825-.261-.975-.3a7.038 7.038 0 0 1 1.431.785 4.477 4.477 0 0 1 1.981 2.425s2.268-2.247 3.533-3.353a3.219 3.219 0 0 0 1-3.8 11.049 11.049 0 0 0-1.917.517 1.665 1.665 0 0 0-.644.427 4.468 4.468 0 0 0-.38.632 3.7 3.7 0 0 1-.446.629z",
    className: "prefix__cls-12",
    "data-name": "Path 5353",
    transform: "translate(-1557.268 -922.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5354",
    d: "M1607.14 959.652c2.046-1.372 1.782-2.442 1.782-2.442a3.6 3.6 0 0 0-3.548.81c-1.646 1.435-1.2 2.686-1.2 2.686s.507.594 2.966-1.054z",
    className: "prefix__cls-9",
    "data-name": "Path 5354",
    transform: "translate(-1579.556 -927.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5355",
    d: "M1597.669 964.775a1.68 1.68 0 0 1-.45-3.3c2.139-.6 3.4-1.617 3.551-2.875.182-1.524-1.21-3.394-3.465-4.654a1.68 1.68 0 1 1 1.638-2.932 11.472 11.472 0 0 1 3.937 3.48 6.633 6.633 0 0 1 1.225 4.505 5.783 5.783 0 0 1-1.829 3.526 9.765 9.765 0 0 1-4.156 2.187 1.677 1.677 0 0 1-.451.063z",
    className: "prefix__cls-10",
    "data-name": "Path 5355",
    transform: "translate(-1574.911 -923.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5356",
    d: "M1594.274 950.464c1.266 1.106 3.533 3.353 3.533 3.353a4.477 4.477 0 0 1 1.98-2.425 4.4 4.4 0 0 1 2.791-1.055 37.71 37.71 0 0 0-4.763-4.7l-.057-.042a3.058 3.058 0 0 0-4.27.691 3.148 3.148 0 0 0 .786 4.178z",
    className: "prefix__cls-11",
    "data-name": "Path 5356",
    transform: "translate(-1573.2 -920.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5357",
    d: "M1596.66 951.065a1.842 1.842 0 0 0 .366.355.258.258 0 0 0 .308.022c.222-.117.277-.122.452.072a2.816 2.816 0 0 1 .334.474c.186.323.333.677.511 1 .082.147.3.652.505.638a.315.315 0 0 0 .126-.047q.481-.258.982-.476c.166-.072.825-.261.975-.3a7.05 7.05 0 0 0-1.431.785 4.476 4.476 0 0 0-1.98 2.425s-2.268-2.247-3.534-3.353a3.22 3.22 0 0 1-1-3.8 11.047 11.047 0 0 1 1.917.517 1.662 1.662 0 0 1 .644.427 4.434 4.434 0 0 1 .38.632 3.715 3.715 0 0 0 .445.629z",
    className: "prefix__cls-12",
    "data-name": "Path 5357",
    transform: "translate(-1573.201 -922.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5358",
    d: "M1597.48 958.806c-1.333-8.112-4.175-9.552-4.175-9.552h-3.844l-.571.026-.165 7.784-.022 1.742z",
    className: "prefix__cls-11",
    "data-name": "Path 5358",
    transform: "translate(-1570.747 -922.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5359",
    d: "M1594.348 964.058c1.974-.09 3.788-.231 4.454-.286a.245.245 0 0 0 .221-.288l-.16-.883a.245.245 0 0 0-.255-.2c-.608.033-2.414.129-4.314.206a.246.246 0 0 0-.236.254l.032.963a.246.246 0 0 0 .258.234z",
    className: "prefix__cls-13",
    "data-name": "Path 5359",
    transform: "translate(-1573.807 -930.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5360",
    d: "M1595.2 964.4l.575-.028a.107.107 0 0 0 .1-.112l-.018-.415a.107.107 0 0 0-.113-.1l-.563.031a.107.107 0 0 0-.1.109l.006.412a.108.108 0 0 0 .113.103z",
    className: "prefix__cls-12",
    "data-name": "Path 5360",
    transform: "translate(-1574.39 -930.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5361",
    d: "M1597.7 964.163l2.78-.186a.127.127 0 0 0 .116-.151.127.127 0 0 0-.133-.1l-2.778.189a.127.127 0 0 0-.118.135.127.127 0 0 0 .133.113z",
    className: "prefix__cls-12",
    "data-name": "Path 5361",
    transform: "translate(-1575.813 -930.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5362",
    d: "M1577.1 958.806l-.022-1.742.165-7.784-.9-.026h-3.843s-2.841 1.44-4.175 9.552z",
    className: "prefix__cls-11",
    "data-name": "Path 5362",
    transform: "translate(-1559.103 -922.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_357",
    cx: 0.693,
    cy: 0.693,
    r: 0.693,
    className: "prefix__cls-9",
    "data-name": "Ellipse 357",
    transform: "translate(17.283 33.101)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_358",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    className: "prefix__cls-12",
    "data-name": "Ellipse 358",
    transform: "translate(17.346 33.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5363",
    d: "M1588.455 965.3l.182-.182a.058.058 0 0 0-.082-.081l-.182.182-.182-.182a.058.058 0 0 0-.081.081l.182.182-.182.182a.057.057 0 0 0 0 .081.057.057 0 0 0 .081 0l.182-.182.182.182a.057.057 0 0 0 .082 0 .058.058 0 0 0 0-.081z",
    className: "prefix__cls-13",
    "data-name": "Path 5363",
    transform: "translate(-1570.399 -931.571)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_359",
    cx: 0.693,
    cy: 0.693,
    r: 0.693,
    fill: "#737373",
    "data-name": "Ellipse 359",
    transform: "translate(17.283 37.09)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_360",
    cx: 0.63,
    cy: 0.63,
    r: 0.63,
    fill: "#d7d7d7",
    "data-name": "Ellipse 360",
    transform: "translate(17.346 37.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_70",
    d: "M0.445 0L0 0.445",
    className: "prefix__cls-16",
    "data-name": "Line 70",
    transform: "translate(17.753 37.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_71",
    d: "M0 0L0.445 0.445",
    className: "prefix__cls-16",
    "data-name": "Line 71",
    transform: "translate(17.753 37.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5364",
    d: "M1572.059 964.864l-.531 3.611 2.939 1.008 2.939-.84-.126-3.779h-5.222",
    className: "prefix__cls-12",
    "data-name": "Path 5364",
    transform: "translate(-1560.933 -931.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5365",
    d: "M1572.4 964.864l-.5 3.414 2.779.953 2.779-.794-.119-3.573h-4.939",
    className: "prefix__cls-11",
    "data-name": "Path 5365",
    transform: "translate(-1561.147 -931.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5366",
    d: "M1572.135 962.278a32.3 32.3 0 0 1 5.5.13l.144 1.375-3.181.7-2.817-.8z",
    className: "prefix__cls-12",
    "data-name": "Path 5366",
    transform: "translate(-1561.077 -929.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5367",
    d: "M1572.564 962.448a34.37 34.37 0 0 1 5.291.126v1.218l-2.939.63-2.6-.714z",
    className: "prefix__cls-11",
    "data-name": "Path 5367",
    transform: "translate(-1561.38 -930.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5368",
    d: "M1580.738 966.809l.01 3.194h.242v-3.275z",
    className: "prefix__cls-12",
    "data-name": "Path 5368",
    transform: "translate(-1566.195 -932.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5369",
    d: "M1575.462 966.68l-.294 3.166-.21-.084.294-3.233.21.151",
    className: "prefix__cls-12",
    "data-name": "Path 5369",
    transform: "translate(-1562.892 -932.433)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_361",
    cx: 0.357,
    cy: 0.357,
    r: 0.357,
    className: "prefix__cls-12",
    "data-name": "Ellipse 361",
    transform: "translate(13.241 33.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5370",
    d: "M1587.824 947.532c0 1.072-2.8 4.61-2.8 4.61s-2.747-3.538-2.747-4.61 1.084-1.941 2.67-1.941 2.877.869 2.877 1.941z",
    className: "prefix__cls-10",
    "data-name": "Path 5370",
    transform: "translate(-1567.077 -920.468)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_362",
    cx: 2.645,
    cy: 1.533,
    className: "prefix__cls-17",
    "data-name": "Ellipse 362",
    rx: 2.645,
    ry: 1.533,
    transform: "translate(15.288 24.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5371",
    d: "M1588.748 952.745l1.683-1.272 1.709 1.224a.229.229 0 0 0 .314-.045c.665-.842 3.478-4.551 2.243-5.547-1.4-1.126-3.422.18-3.422.18 1.125.766-2.527 5.46-2.527 5.46z",
    className: "prefix__cls-9",
    "data-name": "Path 5371",
    transform: "translate(-1570.772 -921.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5372",
    d: "M1588.754 952.916l1.724-1.6 1.758 1.26s3.443-4.157 2.141-5.206-3.191.168-3.191.168c1.05.718-2.432 5.378-2.432 5.378z",
    className: "prefix__cls-12",
    "data-name": "Path 5372",
    transform: "translate(-1570.776 -921.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5373",
    d: "M1580.4 952.745l-1.683-1.272-1.709 1.224a.229.229 0 0 1-.313-.045c-.666-.842-3.479-4.551-2.244-5.547 1.4-1.126 3.423.18 3.423.18-1.122.766 2.526 5.46 2.526 5.46z",
    className: "prefix__cls-9",
    "data-name": "Path 5373",
    transform: "translate(-1562.428 -921.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5374",
    d: "M1580.851 952.916l-1.725-1.6-1.758 1.26s-3.443-4.157-2.142-5.206 3.191.168 3.191.168c-1.048.718 2.434 5.378 2.434 5.378z",
    className: "prefix__cls-12",
    "data-name": "Path 5374",
    transform: "translate(-1562.878 -921.243)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3025",
    "data-name": "Group 3025",
    transform: "translate(6.159 9.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5375",
    d: "M1609.59 936.894a2.046 2.046 0 0 1-1.9.354c-.861-.274-.9-1.16-.85-1.942.083-1.195.83-2.738 2.237-2.642a1.839 1.839 0 0 1 1.708 2.508 3.585 3.585 0 0 1-1.195 1.722z",
    className: "prefix__cls-10",
    "data-name": "Path 5375",
    transform: "translate(-1587.26 -922.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5376",
    d: "M1609.77 937.3a1.319 1.319 0 0 1-1.226.229c-.555-.177-.583-.747-.548-1.251.053-.77.535-1.765 1.442-1.7a1.185 1.185 0 0 1 1.1 1.617 2.312 2.312 0 0 1-.768 1.105z",
    className: "prefix__cls-18",
    "data-name": "Path 5376",
    transform: "translate(-1587.925 -923.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5377",
    d: "M1562.484 936.894a2.046 2.046 0 0 0 1.9.354c.861-.274.9-1.16.851-1.942-.083-1.195-.83-2.738-2.237-2.642a1.839 1.839 0 0 0-1.708 2.508 3.585 3.585 0 0 0 1.194 1.722z",
    className: "prefix__cls-10",
    "data-name": "Path 5377",
    transform: "translate(-1561.177 -922.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5378",
    d: "M1564.236 937.3a1.319 1.319 0 0 0 1.226.229c.555-.177.583-.747.548-1.251-.053-.77-.535-1.765-1.442-1.7a1.185 1.185 0 0 0-1.1 1.617 2.313 2.313 0 0 0 .768 1.105z",
    className: "prefix__cls-18",
    "data-name": "Path 5378",
    transform: "translate(-1562.443 -923.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5379",
    d: "M1585.667 919.017c0 4.587-1.347 8.784-9.264 8.784s-9.263-4.2-9.263-8.784 4.147-8.305 9.263-8.305 9.264 3.718 9.264 8.305z",
    className: "prefix__cls-10",
    "data-name": "Path 5379",
    transform: "translate(-1564.584 -909.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5380",
    d: "M1597.932 928.777a.15.15 0 0 1-.143-.105 2.223 2.223 0 0 0-1.556-1.441 2.582 2.582 0 0 0-1.86.246.15.15 0 1 1-.173-.245 2.849 2.849 0 0 1 2.088-.3 2.483 2.483 0 0 1 1.788 1.647.15.15 0 0 1-.1.188.144.144 0 0 1-.044.01z",
    className: "prefix__cls-8",
    "data-name": "Path 5380",
    transform: "translate(-1580.01 -918.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5381",
    d: "M1585.605 941.3a13.563 13.563 0 0 0-2.776.3 2.95 2.95 0 0 0 5.551 0 13.568 13.568 0 0 0-2.775-.3z",
    className: "prefix__cls-5",
    "data-name": "Path 5381",
    transform: "translate(-1573.55 -927.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5382",
    fill: "#db6b52",
    d: "M1588.673 944.291a2.892 2.892 0 0 0-3.8 0 3.475 3.475 0 0 0 3.8 0z",
    "data-name": "Path 5382",
    transform: "translate(-1574.719 -928.48)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_363",
    cx: 0.644,
    cy: 0.816,
    className: "prefix__cls-8",
    "data-name": "Ellipse 363",
    rx: 0.644,
    ry: 0.816,
    transform: "translate(14.266 10.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5383",
    d: "M1575.419 928.777a.161.161 0 0 1-.045-.007.15.15 0 0 1-.1-.188 2.484 2.484 0 0 1 1.788-1.647 2.851 2.851 0 0 1 2.088.3.15.15 0 0 1-.173.245 1.773 1.773 0 0 0-.484-.2 3.057 3.057 0 0 0-1.377-.041 2.223 2.223 0 0 0-1.556 1.441.15.15 0 0 1-.141.097z",
    className: "prefix__cls-8",
    "data-name": "Path 5383",
    transform: "translate(-1569.229 -918.932)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_364",
    cx: 0.644,
    cy: 0.816,
    className: "prefix__cls-8",
    "data-name": "Ellipse 364",
    rx: 0.644,
    ry: 0.816,
    transform: "translate(8.558 10.257)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_365",
    cx: 2.104,
    cy: 2.104,
    r: 2.104,
    className: "prefix__cls-17",
    "data-name": "Ellipse 365",
    transform: "translate(15.528 11.526)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_366",
    cx: 2.104,
    cy: 2.104,
    r: 2.104,
    className: "prefix__cls-17",
    "data-name": "Ellipse 366",
    transform: "translate(3.978 11.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5386",
    d: "M1568.812 917.232a17.085 17.085 0 0 1 8.36-2.074 16.852 16.852 0 0 1 8.724 2.54s2.5-8.651-8.724-8.651-8.36 8.185-8.36 8.185z",
    className: "prefix__cls-8",
    "data-name": "Path 5386",
    transform: "translate(-1565.352 -908.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5387",
    d: "M1568.812 916.532a17.085 17.085 0 0 1 8.36-2.074A16.852 16.852 0 0 1 1585.9 917s2.5-8.652-8.724-8.652-8.364 8.184-8.364 8.184z",
    className: "prefix__cls-7",
    "data-name": "Path 5387",
    transform: "translate(-1565.352 -908.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5388",
    d: "M1573.835 910.945c7.895 0 10.532 3.42 11.127 4.4a9.933 9.933 0 0 0-.553-2.205 5.26 5.26 0 0 0-3.343-3.169q-.612-.211-1.234-.392a14.88 14.88 0 0 0-11.834-.014q-.645.186-1.28.405a5.26 5.26 0 0 0-3.343 3.169 9.887 9.887 0 0 0-.551 2.191c.587-.999 3.155-4.385 11.011-4.385z",
    className: "prefix__cls-8",
    "data-name": "Path 5388",
    transform: "translate(-1562.118 -908.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5389",
    d: "M1582.654 920.616l.355-2.666.373 2.538z",
    className: "prefix__cls-10",
    "data-name": "Path 5389",
    transform: "translate(-1573.45 -913.834)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5390",
    d: "M1573.047 924.389l.1-1.515.3 1.49z",
    className: "prefix__cls-10",
    "data-name": "Path 5390",
    transform: "translate(-1567.96 -916.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5391",
    d: "M1596.162 922.19l.443-1.779.109 1.833z",
    className: "prefix__cls-10",
    "data-name": "Path 5391",
    transform: "translate(-1581.168 -915.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5392",
    d: "M1599.845 923.413l.336-1.306-.026 1.35z",
    className: "prefix__cls-10",
    "data-name": "Path 5392",
    transform: "translate(-1583.273 -916.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5393",
    d: "M1605.763 924.932l.286-2.1.026 2.121z",
    className: "prefix__cls-10",
    "data-name": "Path 5393",
    transform: "translate(-1586.655 -916.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5394",
    d: "M1580.4 921.775l.014-1.852.254 1.835z",
    className: "prefix__cls-10",
    "data-name": "Path 5394",
    transform: "translate(-1572.161 -914.961)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5395",
    d: "M1570.25 909.4c7.524 0 13.65 3.162 13.889 7.111 0-.084.008-.169.008-.254 0-4.332-6.221-8.786-13.9-8.786s-13.9 4.454-13.9 8.786c0 .085 0 .17.008.254.245-3.949 6.372-7.111 13.895-7.111z",
    className: "prefix__cls-4",
    "data-name": "Path 5395",
    transform: "translate(-1552.262 -898.685)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicture04);
export default __webpack_public_path__ + "static/media/profile-picture-04.245077a05809fc0e536b2267f17372b0.svg";
export { ForwardRef as ReactComponent };